import React from 'react';
import { useParams, Link } from 'react-router-dom';
import parser from 'html-react-parser';
import { Helmet } from 'react-helmet-async';
import SectionHeading from '../Components/SectionHeading/SectionHeading';
import Team from "../utils/teamdata";

export default function TeamMemberPage() {
  const { memberId } = useParams();
  const member = Team.find(m => m.id === memberId);

  if (!member) {
    return (
      <div className="container">
        <div className="st-height-b125 st-height-lg-b80"></div>
        <SectionHeading title="Member Not Found" subTitle="This team member could not be found." />
        <div className="text-center">
          <Link to="/team" className="st-btn st-style1 st-color1">Back to Team</Link>
        </div>
        <div className="st-height-b120 st-height-lg-b80"></div>
      </div>
    );
  }

  return (
    <>
      <Helmet>
        <title>{`${member.name} - ${member.designation} | Pav Dental Team`}</title>
        <meta name="description" content={member.bio.replace(/<br \/>/g, ' ')} />
      </Helmet>

      <div className="st-height-b125 st-height-lg-b80"></div>

      {/* Hero Banner */}
      {/* <div className="tmp-hero-banner">
        <div className="tmp-hero-inner container">
          <Link to="/team" className="tmp-back-link">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="15 18 9 12 15 6" />
            </svg>
            Back to Team
          </Link>
        </div>
      </div> */}

      <div className="container tmp-wrapper">

        {/* Profile Card */}
        <div className="tmp-profile-card">
          <div className="tmp-profile-image-wrap">
            <img src={member.img} alt={member.name} className="tmp-profile-image" />
            <div className="tmp-image-accent"></div>
          </div>

          <div className="tmp-profile-info">
            <span className="tmp-designation-tag">{member.designation}</span>
            <h1 className="tmp-name">{member.name}</h1>
            <div className="tmp-bio">{parser(member.bio)}</div>

            {/* Quick meta pills */}
            <div className="tmp-meta-row">
              {member.language && (
                <div className="tmp-meta-pill">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/></svg>
                  {member.language}
                </div>
              )}
              {member.date && (
                <div className="tmp-meta-pill">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
                  {member.date}
                </div>
              )}
            </div>

            {member.contact && (
              <div className="tmp-contact-cta">
                {member.contact}
              </div>
            )}
          </div>
        </div>

        {/* Detail Sections */}
        <div className="tmp-sections">

          {member.place && (
            <div className="tmp-section">
              <div className="tmp-section-label">Location</div>
              <p className="tmp-section-text">{member.place}</p>
            </div>
          )}

          {member.education && (
            <div className="tmp-section">
              <div className="tmp-section-label">Professional Background</div>
              <p className="tmp-section-text">{member.education}</p>
            </div>
          )}

          {member.specializations && (
            <div className="tmp-section">
              <div className="tmp-section-label">{member.specializationstitle}</div>
              <ul className="tmp-spec-list">
                {member.specializations.map((spec, i) => (
                  <li key={i} className="tmp-spec-item">
                    <span className="tmp-spec-dot"></span>
                    {spec}
                  </li>
                ))}
              </ul>
            </div>
          )}

          {member.qualifications && (
            <div className="tmp-section">
              <div className="tmp-section-label">{member.qualificationstitle}</div>
              <ul className="tmp-spec-list">
                {member.qualifications.map((qual, i) => (
                  <li key={i} className="tmp-spec-item tmp-qual-item">
                    <span className="tmp-qual-num">{String(i + 1).padStart(2, '0')}</span>
                    {qual}
                  </li>
                ))}
              </ul>
            </div>
          )}

          {member.experience && member.experience.length > 0 && (
            <div className="tmp-section">
              <div className="tmp-section-label">Professional Experience</div>
              <div className="tmp-experience-list">
                {member.experience.map((role, i) => (
                  <div key={i} className="tmp-experience-item">
                    <div className="tmp-experience-header">
                      <div className="tmp-experience-title">{role.title}</div>
                      <div className="tmp-experience-meta">{role.place} &middot; {role.period}</div>
                    </div>
                    {role.practices && role.practices.length > 0 && (
                      <div className="tmp-practices-block">
                        <div className="tmp-practices-label">Practices & institutions</div>
                        <ul className="tmp-practices-list">
                          {role.practices.map((p, j) => (
                            <li key={j} className="tmp-practice-item">{p}</li>
                          ))}
                        </ul>
                      </div>
                    )}
                    {role.details && role.details.length > 0 && (
                      <ul className="tmp-spec-list tmp-experience-details">
                        {role.details.map((d, j) => (
                          <li key={j} className="tmp-spec-item">
                            <span className="tmp-spec-dot"></span>
                            {d}
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                ))}
              </div>
            </div>
          )}

             {member.earlyemploymentexperience && member.earlyemploymentexperience.length > 0 && (
            <div className="tmp-section">
              <div className="tmp-section-label">Early Employment Experience</div>
              <div className="tmp-experience-list">
                {member.earlyemploymentexperience.map((role, i) => (
                  <div key={i} className="tmp-experience-item">
                    <div className="tmp-experience-header">
                      <div className="tmp-experience-title">{role.title}</div>
                      <div className="tmp-experience-meta">{role.place} &middot; {role.period}</div>
                    </div>
                    {role.practices && role.practices.length > 0 && (
                      <div className="tmp-practices-block">
                        <div className="tmp-practices-label">Practices & institutions</div>
                        <ul className="tmp-practices-list">
                          {role.practices.map((p, j) => (
                            <li key={j} className="tmp-practice-item">{p}</li>
                          ))}
                        </ul>
                      </div>
                    )}
                    {role.details && role.details.length > 0 && (
                      <ul className="tmp-spec-list tmp-experience-details">
                        {role.details.map((d, j) => (
                          <li key={j} className="tmp-spec-item">
                            <span className="tmp-spec-dot"></span>
                            {d}
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                ))}
              </div>
            </div>
          )}

          {member.clinicalscope && (
            <div className="tmp-section">
              <div className="tmp-section-label">Clinical Scope</div>
              {Array.isArray(member.clinicalscope) ? (
                <ul className="tmp-spec-list">
                  {member.clinicalscope.map((item, i) => (
                    <li key={i} className="tmp-spec-item">
                      <span className="tmp-spec-dot"></span>
                      {item}
                    </li>
                  ))}
                </ul>
              ) : (
                <p className="tmp-section-text">{member.clinicalscope}</p>
              )}
            </div>
          )}

          {(member.philosophy || member.values) && (
            <div className="tmp-quote-block">
              <div className="tmp-quote-mark">"</div>
              <blockquote className="tmp-quote-text">
                {member.philosophy || member.values}
              </blockquote>
            </div>
          )}

        </div>

        <div className="tmp-footer-nav">
          <Link to="/team" className="tmp-back-btn">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6"/></svg>
            Back to Team
          </Link>
        </div>

      </div>

      <div className="st-height-b120 st-height-lg-b80" />

      <style>{`
        /* ── Tokens ── */
        :root {
          --gold: rgb(146, 90, 39);
          --gold-light: rgba(207, 148, 72, 0.12);
          --gold-mid: rgba(207, 148, 72, 0.35);
          --dark: rgb(207, 148, 72);
          --text: #3d4456;
          --muted: #7a8299;
          --border: #e8eaf0;
          --bg-soft: #f8f8fb;
          --white: #ffffff;
          --radius: 14px;
          --shadow-sm: 0 2px 12px rgba(0,0,0,0.06);
          --shadow-md: 0 8px 32px rgba(0,0,0,0.10);
        }

        /* ── Hero Banner ── */
        .tmp-hero-banner {
          background: linear-gradient(135deg, #1a1f2e 0%, #252c3f 100%);
          padding: 18px 0;
          margin-bottom: 0;
        }
        .tmp-hero-inner {
          display: flex;
          align-items: center;
        }
        .tmp-back-link {
          display: inline-flex;
          align-items: center;
          gap: 6px;
          color: rgba(255,255,255,0.65);
          text-decoration: none;
          font-family: 'DM Sans', sans-serif;
          font-size: 14px;
          font-weight: 500;
          letter-spacing: 0.02em;
          transition: color 0.2s;
        }
        .tmp-back-link:hover { color: var(--gold); }

        /* ── Main Wrapper ── */
        .tmp-wrapper {
          margin: 0 auto;
          padding-top: 30px;
        }

        /* ── Profile Card ── */
        .tmp-profile-card {
          display: grid;
          grid-template-columns: 280px 1fr;
          gap: 0;
          background: var(--white);
          border-radius: var(--radius);
          box-shadow: var(--shadow-md);
          overflow: hidden;
          margin-bottom: 32px;
          margin-top: -1px;
          border: 1px solid var(--border);
        }
        .tmp-profile-image-wrap {
          position: relative;
          background: linear-gradient(160deg, #1a1f2e 0%, #2d3550 100%);
          overflow: hidden;
        }
        .tmp-profile-image {
          width: 100%;
          height: 100%;
          min-height: 340px;
          object-fit: cover;
          object-position: top center;
          display: block;
          opacity: 0.92;
          transition: opacity 0.3s;
        }
        .tmp-image-accent {
          position: absolute;
          bottom: 0; left: 0; right: 0;
          height: 80px;
          background: linear-gradient(to top, rgba(207,148,72,0.25), transparent);
          pointer-events: none;
        }
        .tmp-profile-info {
          padding: 36px 36px 32px;
          display: flex;
          flex-direction: column;
          justify-content: center;
        }
        .tmp-designation-tag {
          display: inline-block;
          background: var(--gold-light);
          color: var(--gold);
          font-family: 'DM Sans', sans-serif;
          font-size: 12px;
          font-weight: 600;
          letter-spacing: 0.1em;
          text-transform: uppercase;
          padding: 5px 12px;
          border-radius: 20px;
          border: 1px solid var(--gold-mid);
          margin-bottom: 14px;
          width: fit-content;
        }
        .tmp-name {
          font-family: 'Playfair Display', Georgia, serif;
          font-size: 34px;
          font-weight: 700;
          color: var(--dark);
          margin: 0 0 16px;
          line-height: 1.15;
        }
        .tmp-bio {
          font-family: 'DM Sans', sans-serif;
          font-size: 15px;
          line-height: 1.75;
          color: var(--text);
          margin-bottom: 20px;
        }
        .tmp-meta-row {
          display: flex;
          flex-wrap: wrap;
          gap: 10px;
          margin-bottom: 20px;
        }
        .tmp-meta-pill {
          display: inline-flex;
          align-items: center;
          gap: 6px;
          background: var(--bg-soft);
          border: 1px solid var(--border);
          border-radius: 20px;
          padding: 5px 14px;
          font-family: 'DM Sans', sans-serif;
          font-size: 13px;
          color: var(--muted);
          font-weight: 500;
        }
        .tmp-meta-pill svg { color: var(--gold); flex-shrink: 0; }
        .tmp-contact-cta {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          background: var(--dark);
          color: var(--white);
          border-radius: 8px;
          padding: 10px 18px;
          font-family: 'DM Sans', sans-serif;
          font-size: 14px;
          font-weight: 500;
          width: fit-content;
          margin-top: 4px;
        }
        .tmp-contact-cta svg { color: var(--gold); flex-shrink: 0; }

        /* ── Detail Sections ── */
        .tmp-sections {
          display: flex;
          flex-direction: column;
          gap: 6px;
        }
        .tmp-section {
          background: var(--white);
          border: 1px solid var(--border);
          border-radius: var(--radius);
          padding: 28px 32px;
          box-shadow: var(--shadow-sm);
          transition: box-shadow 0.2s;
          animation: fadeUp 0.4s ease both;
        }
        .tmp-section:hover { box-shadow: var(--shadow-md); }
        @keyframes fadeUp {
          from { opacity: 0; transform: translateY(12px); }
          to   { opacity: 1; transform: translateY(0); }
        }
        .tmp-section-label {
          font-family: 'DM Sans', sans-serif;
          font-size: 11px;
          font-weight: 700;
          letter-spacing: 0.12em;
          text-transform: uppercase;
          color: var(--gold);
          margin-bottom: 14px;
          display: flex;
          align-items: center;
          gap: 10px;
        }
        .tmp-section-label::after {
          content: '';
          flex: 1;
          height: 1px;
          background: var(--gold-light);
          border-radius: 1px;
        }
        .tmp-section-text {
          font-family: 'DM Sans', sans-serif;
          font-size: 15px;
          line-height: 1.75;
          color: var(--text);
          margin: 0;
        }

        /* ── Spec List ── */
        .tmp-spec-list {
          list-style: none;
          padding: 0;
          margin: 0;
          display: flex;
          flex-direction: column;
          gap: 10px;
        }
        .tmp-spec-item {
          display: flex;
          align-items: flex-start;
          gap: 12px;
          font-family: 'DM Sans', sans-serif;
          font-size: 15px;
          color: var(--text);
          line-height: 1.6;
          padding: 10px 14px;
          border-radius: 8px;
          background: var(--bg-soft);
          border: 1px solid transparent;
          transition: border-color 0.2s, background 0.2s;
        }
        .tmp-spec-item:hover {
          border-color: var(--gold-mid);
          background: var(--gold-light);
        }
        .tmp-spec-dot {
          width: 8px;
          height: 8px;
          border-radius: 50%;
          background: var(--gold);
          flex-shrink: 0;
          margin-top: 6px;
        }
        .tmp-qual-item { align-items: center; }
        .tmp-qual-num {
          font-family: 'Playfair Display', serif;
          font-size: 13px;
          font-weight: 700;
          color: var(--gold);
          min-width: 28px;
          flex-shrink: 0;
        }

        /* ── Experience ── */
        .tmp-experience-list {
          display: flex;
          flex-direction: column;
          gap: 20px;
        }
        .tmp-experience-item {
          border-left: 3px solid var(--gold-mid);
          padding-left: 18px;
        }
        .tmp-experience-title {
          font-family: 'DM Sans', sans-serif;
          font-size: 16px;
          font-weight: 700;
          color: var(--dark);
          margin-bottom: 3px;
        }
        .tmp-experience-meta {
          font-family: 'DM Sans', sans-serif;
          font-size: 13px;
          color: var(--muted);
          margin-bottom: 12px;
        }
        .tmp-practices-block {
          margin-bottom: 14px;
        }
        .tmp-practices-label {
          font-family: 'DM Sans', sans-serif;
          font-size: 11px;
          font-weight: 700;
          letter-spacing: 0.1em;
          text-transform: uppercase;
          color: var(--muted);
          margin-bottom: 8px;
        }
        .tmp-practices-list {
          list-style: none;
          padding: 0;
          margin: 0;
          display: flex;
          flex-wrap: wrap;
          gap: 6px;
        }
        .tmp-practice-item {
          font-family: 'DM Sans', sans-serif;
          font-size: 12px;
          color: var(--text);
          background: var(--bg-soft);
          border: 1px solid var(--border);
          border-radius: 20px;
          padding: 3px 12px;
        }
        .tmp-experience-details {
          margin-top: 0;
        }

        /* ── Quote Block ── */
        .tmp-quote-block {
          position: relative;
          background: linear-gradient(135deg, #1a1f2e 0%, #252c3f 100%);
          border-radius: var(--radius);
          padding: 40px 40px 36px 56px;
          overflow: hidden;
          margin-top: 6px;
        }
        .tmp-quote-mark {
          position: absolute;
          top: 10px;
          left: 24px;
          font-family: 'Playfair Display', serif;
          font-size: 100px;
          line-height: 1;
          color: var(--gold);
          opacity: 0.25;
          pointer-events: none;
          user-select: none;
        }
        .tmp-quote-text {
          font-family: 'Playfair Display', serif;
          font-size: 18px;
          line-height: 1.75;
          color: rgba(255,255,255,0.88);
          margin: 0;
          font-style: italic;
          position: relative;
          border-left: 3px solid var(--gold);
          padding-left: 20px;
        }

        /* ── Footer Nav ── */
        .tmp-footer-nav {
          display: flex;
          justify-content: flex-start;
          margin-top: 36px;
          margin-bottom: 12px;
        }
        .tmp-back-btn {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          background: transparent;
          border: 1.5px solid var(--border);
          color: var(--text);
          border-radius: 8px;
          padding: 10px 20px;
          font-family: 'DM Sans', sans-serif;
          font-size: 14px;
          font-weight: 500;
          text-decoration: none;
          transition: border-color 0.2s, color 0.2s, background 0.2s;
        }
        .tmp-back-btn:hover {
          border-color: var(--gold);
          color: var(--gold);
          background: var(--gold-light);
        }

        /* ── Responsive ── */
        @media (max-width: 768px) {
          .tmp-profile-card {
            grid-template-columns: 1fr;
          }
          .tmp-profile-image {
            min-height: 280px;
            max-height: 320px;
          }
          .tmp-profile-info {
            padding: 24px 20px 20px;
          }
          .tmp-name { font-size: 26px; }
          .tmp-section { padding: 22px 20px; }
          .tmp-quote-block { padding: 32px 24px 28px 36px; }
          .tmp-quote-text { font-size: 16px; }
        }
      `}</style>
    </>
  );
}